import { combineReducers } from "redux";
import Filters from "./Filters";

const appReducer = combineReducers({
  Filters,
});

const rootReducer = (state, action) => {
  if (action.type === "ON_USER_LOGOUT") {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
